<template lang="pug">
  div(:class="$style.wrapper")
    div(:class="$style.eyecatch")
      div
        h1
          | QRコードを設置するだけ。
          br
          | ARでちょっと楽しく。
        router-link(to="/signin")
          a-button(
            type="primary",
            size="large",
          ) オリジナルARを作成する(無料)

    div(:class="$style.step")
      div(:class="$style.stepItem")
        img(:class="$style.stepImage", src="@/assets/images/top/step1.png")
        div 読み込む
      div(:class="$style.stepItem")
        img(:class="$style.stepImage", src="@/assets/images/top/step2.png")
        div かざす
      div(:class="$style.stepItem")
        img(:class="$style.stepImage", src="@/assets/images/top/step3.png")
        div 体験する

    div(:class="$style.section")
      h2(:class="$style.title")
        | 「QRAR」は、アプリ不要の
        br
        | QRコードから飛び出すARを
        br
        | カンタンに作成できるサービスです

    div(:class="$style.section")
      h2(:class="$style.sectionTitle") とりあえず体験してみる
      div(:class="$style.try")
        div(:class="$style.tryCode")
          img(src="@/assets/images/top/businesscard.png")
        div(:class="$style.trySection")
          div
            div(:class="$style.tryLabel") スマホでQRコードを読み込んでください。
            div(:class="$style.tryText")
              | QRコードを読み込むとWebブラウザを開きます。
              br
              | ブラウザ上で起動したカメラをこちらのQRコードに向けてください。


    div(:class="$style.section")
      h2(:class="$style.sectionTitle") AR作成画面の紹介
      div(:class="$style.featureSection")
        div(:class="$style.featureDescription")
          | ARを実際に作成している編集画面と実機でのAR表示確認を動画で紹介します。
      div(:class="$style.tryMovie")
        video(src="/data/qrar_editor.mp4", autoplay, controls, muted, loop)
        //- img(src="@/assets/images/top/android.png")

    div(:class="$style.section")
      h2(:class="$style.sectionTitle") QRARの特徴
      div(:class="$style.feature")
        div(:class="$style.featureSection")
          h3(:class="$style.featureTitle") アプリ不要
          div(:class="$style.featureDescription")
            | QRARでは、専用アプリをインストールする必要はありません。普段お使いのブラウザでARを表示できるので、気軽に楽しんでいただけます。
        div(:class="$style.featureSection")
          h3(:class="$style.featureTitle") QRコードにかざすだけ
          div(:class="$style.featureDescription")
            | QRコードが、ARを認識するためのARマーカーとなっているので。QRコードを設置するだけで、ARの表示を実現させました。
        div(:class="$style.featureSection")
          h3(:class="$style.featureTitle") 作成後でもデータを更新可
          div(:class="$style.featureDescription")
            | 発行したQRコードに表示される内容は、リアルタイムに更新可能です。入力した内容が古くなる心配はありません。

    div(:class="$style.signupSection")
      router-link(to="/signin")
        a-button(
          type="primary",
          size="large",
        ) オリジナルARを作成する(無料)

    div(:class="$style.section")
      h2(:class="$style.sectionTitle") QRARでできること
      div(:class="$style.function")
        div(:class="$style.functionSection")
          div(:class="$style.functionImageBlock")
            img(:class="$style.functionImage", src="@/assets/images/top/function-1.png")
          div(:class="$style.functionContentBlock")
            h3(:class="$style.functionTitle") テキスト配置
            div(:class="$style.functionDescription")
              | AR上にテキストを好きな場所に配置できます。
              br
              | テキストは、サイズ・カラー・行揃え・幅・高さなどを設定できます。
        div(:class="$style.functionSection")
          div(:class="$style.functionImageBlock")
            img(:class="$style.functionImage", src="@/assets/images/top/function-2.png")
          div(:class="$style.functionContentBlock")
            h3(:class="$style.functionTitle") ソーシャル・ウェブアイコン配置
            div(:class="$style.functionDescription")
              | AR上にアイコンを好きな場所に配置できます。
              br
              | アイコンには、Twitter・Facebook・Instagram・ホームページアイコンを用意しています。AR上でアイコンをタップすると設定したリンク先に遷移します。
        div(:class="$style.functionSection")
          div(:class="$style.functionImageBlock")
            img(:class="$style.functionImage", src="@/assets/images/top/function-3.png")
          div(:class="$style.functionContentBlock")
            h3(:class="$style.functionTitle") プレビューで動作確認
            div(:class="$style.functionDescription")
              | 公開する前にプレビュー用QRコードを使って、ARの動作をスマホから確認することができます。
        div(:class="$style.functionSection")
          div(:class="$style.functionImageBlock")
            img(:class="$style.functionImage", src="@/assets/images/top/function-4.png")
          div(:class="$style.functionContentBlock")
            h3(:class="$style.functionTitle") QRコード生成
            div(:class="$style.functionDescription")
              | ARの作成が完了したら、AR表示用のQRコードを生成・ダウンロードできます。
              br
              | 作成したQRコードは、名刺やイベントポスター、ウェブサイトなどにご自由にお使いください。

</template>
<style module>
  .wrapper {
    width: 100%;
    padding-bottom: 100px;
  }
  .eyecatch {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    /* background-image:
      url('@/assets/images/top/illust-1.png'), url('@/assets/images/top/illust-2.png');
    background-size: 250px, 250px;
    background-position:
      left -80px top 0px, right 30px bottom -30px;
    padding-top: 180px;
    padding-bottom: 170px;
    transition: background 0.3s ease-in-out; */
    padding-top: 80px;
    padding-bottom: 40px;
    @media (--md) {
      height: 500px;
      padding-top: 160px;
      padding-bottom: 60px;
      /* background-position:
        left calc(50% - 420px) top 40px, right calc(50% - 360px) bottom -30px;
      padding-top: 80px;
      padding-bottom: 40px; */
    }
    /* @media (--lg) {
      background-size: 300px, 300px;
      background-position:
        left calc(20% - 200px) top 40px, right calc(20% - 200px) bottom -30px;
    } */
    & h1 {
      font-size: 7vw;
      font-weight: bold;
      text-align: center;
      line-height: 1.75;
      margin-bottom: 1.5em;
      @media (--md) {
        font-size: 4.6rem;
      }
      @media (--xs) {
        font-size: 7.4vw;
      }
    }
  }

  .title {
    font-size: clamp(2rem, 4vw, 3rem);
    font-weight: bold;
    text-align: center;
    letter-spacing: 0.1em;
    line-height: 2.2;
    padding-top: 4em;
    padding-bottom: 5em;
    @media (--md) {
      font-size: clamp(3rem, 4vw, 3.6rem);
    }
  }

  .section {
    padding-top: 40px;
    @media (--md) {
      padding-top: 80px;
    }
  }
  .sectionTitle {
    font-size: 2.4rem;
    font-weight: bold;
    text-align: center;
    padding-top: 1em;
    padding-bottom: 1em;
    @media (--md) {
      font-size: 3.2rem;
    }
  }
  .step {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 700px;
    padding-top: 30px;
    padding-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
    @media (--md) {
      max-width: 700px;
      padding-top: 30px;
      padding-bottom: 60px;
    }
    @media (--lg) {
      max-width: 900px;
    }
  }
  .stepItem {
    position: relative;
    flex: 1 1 33.33%;
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
    @media (--md) {
      font-size: 2.4rem;
    }
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      top: 35%;
      right: -7px;
      width: 0;
      height: 0;
      border-left: 12px solid var(--black);
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      transform: translateY(-50%);
    }
  }
  .stepImage {
    width: 100%;
    max-width: 180px;
    padding: 0 10%;
    margin-bottom: 20px;
    @media (--md) {
      max-width: 190px;
    }
    @media (--lg) {
      min-width: 220px;
    }
  }
  .registerButton {
    text-align: center;
  }

  .try {
    max-width: 672px;
    padding: 0 16px;
    margin: 0 auto;
  }
  .tryCode {
    max-width: 455px;
    box-shadow: 0 10px 20px -8px color-mod(var(--black) a(15%));
    border: 1px solid var(--gray-lightest);
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 30px;
    & img {
      width: 100%;
    }
  }
  .trySection {
    display: flex;
    justify-content: center;
  }
  .tryLabel {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 0.8em;
  }
  .tryText {
    font-size: 1.4rem;
  }
  .tryMovie {
    max-width: 900px;
    width: 100%;
    margin: 60px auto;
    & video {
      width: 100%;
    }
  }
  /* .tryMovie {
    position: relative;
    width: 300px;
    margin: 60px auto;
    & video {
      width: 277.97px;
      margin-top: 12.3px;
      margin-left: 9.5px;
      border: 1px solid #000;
    }
    & img {
      position: absolute;
      width: 300px;
      left: 0;
    }
  } */

  .featureSection {
    max-width: calc(var(--section-width) + 32px);
    padding: 0 16px;
    margin-left: auto;
    margin-right: auto;
    & + .featureSection {
      margin-top: 40px;
    }
  }
  .featureTitle {
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1em;
    @media (--md) {
      font-size: 2.4rem;
    }
  }
  .featureDescription {
    font-size: 1.6rem;
  }

  .functionSection {
    max-width: calc(var(--section-width) + 32px);
    padding: 0 16px;
    margin-left: auto;
    margin-right: auto;
    & + .functionSection {
      margin-top: 40px;
    }
    @media (--sm) {
      display: flex;
    }
  }
  .functionImageBlock {
    flex: 0 0 30%;
    text-align: center;
    @media (--sm) {
      text-align: left;
    }
  }
  .functionContentBlock {
    flex: 1 1 70%;
    padding-top: 16px;
    @media (--sm) {
      padding: 8px 0 8px 16px;
    }
  }
  .functionImage {
    width: 100%;
    max-width: 180px;
  }
  .functionTitle {
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1em;
    @media (--sm) {
      text-align: left;
    }
    @media (--md) {
      font-size: 2.4rem;
    }
  }
  .functionDescription {
    font-size: 1.6rem;
    text-align: center;
    @media (--sm) {
      text-align: left;
    }
  }

  .signupSection {
    text-align: center;
    padding-top: 60px;
    padding-bottom: 80px;
  }
</style>
<script>

export default {
  name: 'home',
  metaInfo: {
    title: 'QRコード型WebAR作成ツール QRAR',
    titleTemplate: '',
    meta: [
      {
        vmid: 'viewport',
        name: 'viewport',
        content: 'width=device-width, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0',
      },
    ],
  },
}
</script>
